var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hero"},[_vm._v("\n    博客\n  ")]),_c('ul',_vm._l((_vm.postToc),function(post){return _c('li',{key:post.id},[_c('router-link',{attrs:{"to":("/blog/" + (post.id))}},[_vm._v("\n      "+_vm._s(post.title)+"\n      ")])],1)}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfd7abfa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogHome.vue
// module id = null
// module chunks = 